import Stack from '@mui/material/Stack';
import React from 'react';
import { DegreeProgressionList } from '@/components/chord_progression/converter/DegreeProgressionList';
import { SelectedKeyProgressionList } from '@/components/chord_progression/converter/SelectedKeyProgressionList';
import { Progression } from '@/components/chord_progression/converter/types';
import * as Chord from '@/lib/chord';

export const Result = (props: {
  phraseKey: string;
  alphabetProgressions: Progression[];
}) => {
  const { phraseKey, alphabetProgressions } = props;

  const degreeProgressions = convertToDegree(phraseKey, alphabetProgressions);

  return (
    <Stack spacing={2}>
      <DegreeProgressionList degreeProgressions={degreeProgressions} />
      <SelectedKeyProgressionList degreeProgressions={degreeProgressions} />
    </Stack>
  );
};

const convertToDegree = (
  phraseKey: string,
  alphabetProgressions: Progression[]
): Progression[] => {
  return alphabetProgressions.map((progression) => {
    if (progression.type !== 'chords') {
      return progression;
    }

    const degreeChords = progression.value.map((alphabetChord) => {
      return Chord.convertToDegree(phraseKey, alphabetChord);
    });

    return { ...progression, value: degreeChords };
  });
};
